import { CUSTOM_ELEMENTS_SCHEMA, Component, computed, input } from '@angular/core';
import { getInstitutoStatusCor } from '../../../core/constants/instituto-previdenciario-opcoes';

/**
 * Tag de status do Instituto Previdenciário: o `vivest-tag` do design system com as cores de
 * `getInstitutoStatusCor`, que não cabem nas variantes da tag (amarelo, laranja...).
 */
@Component({
  selector: 'app-instituto-status-tag',
  standalone: true,
  // Web component do design system Vivest (`vivest-tag`).
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './instituto-status-tag.component.html',
  styleUrl: './instituto-status-tag.component.scss',
})
export class InstitutoStatusTagComponent {
  readonly status = input<string | null | undefined>(null);

  readonly cor = computed(() => getInstitutoStatusCor(this.status()));
}
